/**
 * Beitraege und Anhaenge eines Tickets.
 *
 * Wie ueberall: Die Typen kommen aus dem erzeugten Schema, nicht aus einer
 * zweiten Beschreibung von Hand.
 */

import type { components } from '../../../api/schema';
import { download, request, upload } from '../../../lib/apiClient';

export type Article = components['schemas']['ArticleRead'];
export type ArticleCreate = components['schemas']['ArticleCreate'];
export type ArticleUpdate = components['schemas']['ArticleUpdate'];
export type ArticleType = components['schemas']['ArticleType'];
export type ArticleVisibility = components['schemas']['ArticleVisibility'];
export type Attachment = components['schemas']['AttachmentRead'];
export type TicketAttachment = components['schemas']['TicketAttachmentRead'];
export type AttachmentSource = components['schemas']['AttachmentSource'];
export type ReplyDefaults = components['schemas']['ReplyDefaults'];
export type ReplyContact = components['schemas']['ReplyContact'];

export function listArticles(ticketId: string): Promise<Article[]> {
  return request<Article[]>(`/tickets/${ticketId}/articles`);
}

/** Vorbelegung und Vorschlaege der Antwort -- F3-22. */
export function getReplyDefaults(ticketId: string): Promise<ReplyDefaults> {
  return request<ReplyDefaults>(`/tickets/${ticketId}/articles/reply-defaults`);
}

export function createArticle(ticketId: string, payload: ArticleCreate): Promise<Article> {
  return request<Article>(`/tickets/${ticketId}/articles`, { method: 'POST', body: payload });
}

export function updateArticle(
  ticketId: string,
  articleId: string,
  payload: ArticleUpdate,
): Promise<Article> {
  return request<Article>(`/tickets/${ticketId}/articles/${articleId}`, {
    method: 'PATCH',
    body: payload,
  });
}

export function publishArticle(ticketId: string, articleId: string): Promise<Article> {
  return request<Article>(`/tickets/${ticketId}/articles/${articleId}/actions/publish`, {
    method: 'POST',
  });
}

export function deleteArticle(ticketId: string, articleId: string): Promise<undefined> {
  return request<undefined>(`/tickets/${ticketId}/articles/${articleId}`, { method: 'DELETE' });
}

/**
 * Alle Dateien eines Tickets -- aus beiden Richtungen.
 *
 * Der Verlauf zeigt jeden Anhang unter seinem Beitrag. Diese Liste zieht sie
 * heraus und traegt je Datei, von welcher Seite sie kam. Der Server
 * entscheidet, was ein Portalnutzer davon sieht.
 */
export function listTicketAttachments(ticketId: string): Promise<TicketAttachment[]> {
  return request<TicketAttachment[]>(`/tickets/${ticketId}/attachments`);
}

export function uploadAttachment(ticketId: string, file: File): Promise<Attachment> {
  return upload<Attachment>(`/tickets/${ticketId}/attachments`, file);
}

export function deleteAttachment(attachmentId: string): Promise<undefined> {
  return request<undefined>(`/attachments/${attachmentId}`, { method: 'DELETE' });
}

export function downloadAttachment(attachmentId: string) {
  return download(`/attachments/${attachmentId}/content`);
}
